const menu = [
  { label: 'Home', to: 'home' },
  { label: 'Airbnb-servicekosten', to: 'airbnb' },
  // { label: 'Kennisbank', to: 'knowledgebase' },
  { label: 'Makelaarskosten', to: 'agencyFee' },
  { label: 'Blog', to: 'blog' },
  { label: 'Contact', to: 'contact' },
  { label: 'Mijn  ', to: 'airbnbDashboard' },
]

export default menu
